import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import PageBackground from "@/components/PageBackground";
import { Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setMessage(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data.message || "If an account with that email exists, a reset link has been generated.");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-16 relative">
      <PageBackground variant="cyan-lav" />
      <div className="glass-strong rounded-[28px] w-full max-w-md p-8 relative z-10 fade-up">
        <div className="pf-chip pf-chip-cyan mx-auto w-fit">Forgot password</div>
        <h1 className="font-display text-4xl font-medium tracking-tight mt-4 text-center text-slate-900">Reset your password</h1>
        <p className="text-sm text-slate-600 mt-2 text-center">
          Enter your email and we'll send a secure reset link.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-form">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-widest text-slate-500 mb-2">Email</label>
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="pf-input w-full pl-10 pr-4 py-3 text-sm" data-testid="forgot-email" placeholder="you@example.com" />
            </div>
          </div>

          {error && <div className="text-sm text-red-600 bg-red-50/70 backdrop-blur border border-red-200 rounded-xl px-4 py-2" data-testid="forgot-error">{error}</div>}
          {message && <div className="text-sm text-emerald-700 bg-emerald-50/70 backdrop-blur border border-emerald-200 rounded-xl px-4 py-3" data-testid="forgot-success">{message}<br /><span className="text-xs text-slate-500">Check the backend logs for the reset URL during development.</span></div>}

          <button type="submit" disabled={loading} className="pf-btn-primary w-full py-3 rounded-full font-semibold" data-testid="forgot-submit">
            {loading ? "Sending..." : "Send reset link"}
          </button>
        </form>

        <div className="mt-6 text-sm text-slate-600 text-center">
          Remembered it? <Link to="/login" className="text-cyan-700 font-semibold hover:underline">Back to login</Link>
        </div>
      </div>
    </div>
  );
}
